/** @format */

module.exports = [
  {
    name: "germany",
    title: "German flow",
  },
  {
    name: "germany-existing-customers",
    title: "German flow for existing customers",
  },
];



// WEBPACK FOOTER //
// ./src/partners/config/variants.js